import { render } from "./ModalSuccess.vue?vue&type=template&id=1b089a53"
import script from "./ModalSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&lang=js"

import "./ModalSuccess.vue?vue&type=style&index=0&id=1b089a53&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__